<template>
    <v-dialog v-model="dialog" width="35vw">
        <v-card>
            <v-card-title>Send invite to host to set a password
            </v-card-title>      
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12" class="mb-4">
                        {{ 'An invitation to set a password will be sent by mail to ' + eign_email + '. This mail will contain a link that is valid for 48 hours. The link can be used to set a password.' }}
                    </v-col>
                </v-row>     
            </v-card-text>         
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="close" class="mb-2">Close</v-btn>
                <v-btn color="primary" v-bind:disabled="loading" v-bind:loading="loading" v-on:click="sendInvite()" small class="mb-2">
                    <v-icon left>mdi-email-fast-outline</v-icon>Send invite
                    <template v-slot:loader>
                        <span class="custom-loader">
                            <v-icon light>mdi-cached</v-icon>
                        </span>
                    </template>
                </v-btn>            
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        props: {
            eign_encrid: String, eign_email: String
        },     
        mounted(){
        },   
        components: {
        },      
        data() {
            return {
                dialog: false,
                loading: false,
            }
        },
        methods: {
            open() {
                this.dialog = true;
            },
            close() {
                this.dialog = false;
            },
            sendInvite() {
                // Logic to send the invitation
                this.loading = true
                this.$axios
                .post("ares/json/ares/eign/inviteToSetPasswordMail.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPassword"
                    },
                    setPassword: {
                        eign_encrid: this.eign_encrid,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false
                    } else {
                        this.loading = false
                        this.close(); // clear any ongoing updates
                    }
                })                      
            }
        }
    }
</script>

<style scoped>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    @-moz-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @-webkit-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @-o-keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    }
    @keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(360deg);}
    } 

</style>